window.addEventListener("DOMContentLoaded", () => {

    // -------------------------------------------------------------------------
    // Helpers
    // -------------------------------------------------------------------------

    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }

    function getOfferCookie() {
        const raw = getCookie('mmg_spacial_offer');
        if (!raw) return null;
        try {
            return JSON.parse(atob(raw));
        } catch (e) {
            return null;
        }
    }

    function setCookieWithExpiration(name, value, expirationTimestamp) {
        const expirationDate = new Date(expirationTimestamp * 1000).toUTCString();
        document.cookie = `${name}=${value}; path=/; expires=${expirationDate}`;
    }

    function formatLocal(timestamp) {
        const d = new Date(timestamp * 1000);
        const pad = n => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    }

    function getSalePrice(regularPrice, discountPercentage, staticSalePrice) {
        if (30 === discountPercentage && staticSalePrice !== undefined && staticSalePrice !== null && staticSalePrice !== '') {
            return Number(staticSalePrice).toFixed(2);
        }

        const salePrice = parseFloat(regularPrice) * (1 - (discountPercentage / 100));
        return Number(salePrice).toFixed(2);
    }

    function getPriceHtml(price, currencyIso, currencySymbol, isSale) {
        const className = isSale ? 'mmg-product-sale-price' : 'mmg-product-regular-price';
        return `<span class="${className}"><span><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">${currencySymbol}</span>${price}</bdi></span><span class="currency-format">${currencyIso}</span></span></span>`;
    }

    function formatSavings(regularPrice, salePrice, currencySymbol) {
        const diff = Math.round((parseFloat(regularPrice) - parseFloat(salePrice)) * 100) / 100;
        if (!(diff > 0)) return '';
        const amount = Number.isInteger(diff) ? diff : diff.toFixed(2);
        return `${currencySymbol}${amount}`;
    }

    // -------------------------------------------------------------------------
    // Cookie init - runs once before rendering.
    // If any block on the page has always_enabled and no cookie exists, set it.
    // -------------------------------------------------------------------------

    function initOfferCookie(wrappers) {
        const hasAlwaysEnabled = Array.from(wrappers).some(
            w => w.dataset.always_enabled === '1'
        );

        if (hasAlwaysEnabled && !getCookie('mmg_spacial_offer') && window.WooSaleOffer) {
            const now = Math.floor(Date.now() / 1000);
            window.WooSaleOffer.offer_data.expires_at = now + (window.WooSaleOffer.offer_hours * 60 * 60);
            const encoded = btoa(JSON.stringify(window.WooSaleOffer.offer_data));
            setCookieWithExpiration('mmg_spacial_offer', encoded, window.WooSaleOffer.offer_data.expires_at);
        }
    }

    // -------------------------------------------------------------------------
    // Render a single wrapper based on current offer state.
    // -------------------------------------------------------------------------

    function renderWrapper(wrapper, offerData, blockType) {
        const {currency_symbol, currency_iso, regular_price, sale_price, offer_available, static_sale_price} = wrapper.dataset;

        const regularPriceWrappers = wrapper.querySelectorAll('.mmg-wso-regular-price');
        const mainPriceWrappers = wrapper.querySelectorAll('.mmg-wso-main-price');

        // blockType == 5
        const saveWrappers = wrapper.querySelectorAll('.mmg-wso-save');
        const showSavings = salePrice => {
            const savings = formatSavings(regular_price, salePrice, currency_symbol);
            saveWrappers.forEach(w => {
                if (!savings) {
                    w.remove();
                    return;
                }
                w.classList.remove('hidden');
                w.querySelector('.mmg-wso-save-amount').textContent = savings;
            });
        };

        // blockType == 2 || 4
        const countdownWrappers = wrapper.querySelectorAll('.mmg-wso-countdown');
        const offerText = wrapper.querySelectorAll('.mmg-wso-offer-text');

        // blockType == 3
        const activeOfferText = wrapper.querySelectorAll('.mmg-wso-active-offer-text');
        const inactiveOfferText = wrapper.querySelectorAll('.mmg-wso-inactive-offer-text');
        const offerButton = wrapper.querySelectorAll('.mmg-wso-button');

        const loggedIn = document.querySelector('body').classList.contains('logged-in');

        if (offerData && offerData.expires_at && (!loggedIn || '1' === offer_available) ) {
            // Active cookie offer
            if (2 === blockType || 4 === blockType) {
                countdownWrappers.forEach(el => {
                    el.classList.remove('hidden');
                    const countdown = el.querySelector('.wp-block-mmg-countdown');
                    if (countdown && countdown.mmgCountdown && countdown.mmgCountdown.setDate) {
                        countdown.mmgCountdown.setDate(formatLocal(offerData.expires_at));
                    }
                });
                offerText.forEach(el => el.classList.remove('hidden'));
            } else if (3 === blockType) {
                let discount = offerData.discount + '%';
                activeOfferText.forEach(el => {
                    el.classList.remove('hidden');
                    el.querySelector('.mmg-wso-offer-percent').innerHTML = discount;
                });
                inactiveOfferText.forEach(w => w.remove());
                offerButton.forEach(w => {
                    w.querySelector('a').innerHTML = `Get ${discount} Off`
                });
            }

            regularPriceWrappers.forEach(w => {
                w.classList.remove('hidden');
                const del = w.querySelector('del');
                if (del) del.innerHTML = getPriceHtml(regular_price, currency_iso, currency_symbol, false);
            });

            mainPriceWrappers.forEach(w => {
                w.classList.remove('hidden');
                w.innerHTML = getPriceHtml( getSalePrice(regular_price, offerData.discount, static_sale_price), currency_iso, currency_symbol, true);
            });

            showSavings(getSalePrice(regular_price, offerData.discount, static_sale_price));

        } else {
            // No active offer or product is already purchased (not available).
            if (2 === blockType || 4 === blockType) {
                countdownWrappers.forEach(el => el.remove());
                offerText.forEach(el => el.remove());
            } else if (3 === blockType) {
                activeOfferText.forEach(w => w.remove());
                inactiveOfferText.forEach(w => w.classList.remove('hidden'));
            }

            // If the product has a sale price, show it.
            if (sale_price) {
                regularPriceWrappers.forEach(w => {
                    w.classList.remove('hidden');
                    const del = w.querySelector('del');
                    if (del) del.innerHTML = getPriceHtml(regular_price, currency_iso, currency_symbol, false);
                });

                mainPriceWrappers.forEach(w => {
                    w.classList.remove('hidden');
                    w.innerHTML = getPriceHtml(sale_price, currency_iso, currency_symbol, true);
                });

                showSavings(sale_price);
            } else {
                // No sale - show regular price only.
                regularPriceWrappers.forEach(w => w.remove());
                saveWrappers.forEach(w => w.remove());

                mainPriceWrappers.forEach(w => {
                    w.classList.remove('hidden');
                    w.innerHTML = getPriceHtml(regular_price, currency_iso, currency_symbol, false);
                });
            }
        }
    }

    // -------------------------------------------------------------------------
    // Main
    // -------------------------------------------------------------------------

    const saleOfferWrappers = document.querySelectorAll('.mmg-woo-sale-offer');
    if (!saleOfferWrappers.length) return;

    initOfferCookie(saleOfferWrappers);

    const offerData = getOfferCookie();
    saleOfferWrappers.forEach(wrapper => {
        const blockType = wrapper.classList.contains('mmg-woo-sale-offer-type-7') ? 7
            : wrapper.classList.contains('mmg-woo-sale-offer-type-6') ? 6
            : wrapper.classList.contains('mmg-woo-sale-offer-type-5') ? 5
            : wrapper.classList.contains('mmg-woo-sale-offer-type-4') ? 4
            : wrapper.classList.contains('mmg-woo-sale-offer-type-3') ? 3
            : wrapper.classList.contains('mmg-woo-sale-offer-type-2') ? 2
            : 1;

        renderWrapper(wrapper, offerData, blockType)
    });

    // -------------------------------------------------------------------------
    // Sticky footer bars stay in flow until one viewport height has been
    // scrolled, then pin to the bottom edge.
    // -------------------------------------------------------------------------

    const footerBars = document.querySelectorAll('.mmg-woo-sale-offer.is-sticky-bottom');
    if (footerBars.length) {
        let ticking = false;

        const updateFooterBars = () => {
            const pinned = window.scrollY >= window.innerHeight;
            let bottomHeight = 0;

            footerBars.forEach(bar => {
                bar.classList.toggle('is-pinned', pinned);

                if (pinned) {
                    bottomHeight = Math.max(bottomHeight, bar.offsetHeight);
                }
            });

            // Reserve space for a pinned footer bar so it never covers the last content.
            document.body.style.paddingBottom = bottomHeight ? `${bottomHeight}px` : '';
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateFooterBars);
                ticking = true;
            }
        };

        updateFooterBars();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
    }
});
